/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UpdateDiscountDto
 */
export interface UpdateDiscountDto {
  _id?: string;
    /**
     * Display name for the discount
     * @type {string}
     * @memberof UpdateDiscountDto
     */
    name?: string;
    /**
     * Optional description for internal use
     * @type {string}
     * @memberof UpdateDiscountDto
     */
    description?: string;
    /**
     * ITEM_DISCOUNT: Shows on products automatically. COUPON_CODE: Requires code at checkout
     * @type {string}
     * @memberof UpdateDiscountDto
     */
    type?: UpdateDiscountDtoTypeEnum;
    /**
     * PERCENTAGE or FIXED_AMOUNT
     * @type {string}
     * @memberof UpdateDiscountDto
     */
    valueType?: UpdateDiscountDtoValueTypeEnum;
    /**
     * The discount value (percentage 1-100 or fixed dollar amount)
     * @type {number}
     * @memberof UpdateDiscountDto
     */
    value?: number;
    /**
     * Maximum discount amount for percentage discounts (optional, mainly for COUPON_CODE)
     * @type {number}
     * @memberof UpdateDiscountDto
     */
    cappedAt?: number;
    /**
     * Coupon code (required for COUPON_CODE type)
     * @type {string}
     * @memberof UpdateDiscountDto
     */
    code?: string;
    /**
     * When the discount becomes active
     * @type {Date}
     * @memberof UpdateDiscountDto
     */
    startsAt?: Date;
    /**
     * When the discount expires
     * @type {Date}
     * @memberof UpdateDiscountDto
     */
    expiresAt?: Date;
    /**
     * Current lifecycle state
     * @type {string}
     * @memberof UpdateDiscountDto
     */
    state?: UpdateDiscountDtoStateEnum;
    /**
     * Quick toggle to enable/disable the discount
     * @type {boolean}
     * @memberof UpdateDiscountDto
     */
    isActive?: boolean;
    /**
     * Products to apply discount to (all their variants will be discounted)
     * @type {Array<string>}
     * @memberof UpdateDiscountDto
     */
    productsEligible?: Array<string>;
    /**
     * Specific variants to apply discount to
     * @type {Array<string>}
     * @memberof UpdateDiscountDto
     */
    variantsEligible?: Array<string>;
    /**
     * Maximum total times this discount can be used (optional)
     * @type {number}
     * @memberof UpdateDiscountDto
     */
    maxUses?: number;
    /**
     * Maximum times a single user can use this discount (optional)
     * @type {number}
     * @memberof UpdateDiscountDto
     */
    maxUsesPerUser?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateDiscountDtoTypeEnum {
    ITEMDISCOUNT = 'ITEM_DISCOUNT',
    COUPONCODE = 'COUPON_CODE'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateDiscountDtoValueTypeEnum {
    PERCENTAGE = 'PERCENTAGE',
    FIXEDAMOUNT = 'FIXED_AMOUNT'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateDiscountDtoStateEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    EXPIRED = 'EXPIRED',
    SCHEDULED = 'SCHEDULED'
}

